import api from "../product/api";

/**
 * Recherche publique des lots publiés (agri-product-platform), sans JWT :
 *
 *   GET /marketplace/search?q=&country=&category=&subCategory=&page=&size=
 *     -> { items: [lot], page, size, total, matched: [{ level, code, parentCode, labelFr, labelEn }] }
 *   GET /marketplace/search/suggestions?q=&country=&limit=
 *     -> [{ level: PRODUCT | SUB_CATEGORY | CATEGORY, code, parentCode, labelFr, labelEn, offers }]
 *
 * Les lots ont la forme de /marketplace/sub-category/{nom} (cartes ProductDiscoveryCard).
 */
export const searchProducts = async ({ q = "", country, category, subCategory, page = 0, size }) => {
    const { data } = await api.get("/marketplace/search", {
        params: { q, country, category, subCategory, page, size },
    });
    return {
        items: data?.items || [],
        total: data?.total ?? 0,
        matched: data?.matched || [],
    };
};

export const productSuggestions = async ({ q, country, limit }) => {
    const { data } = await api.get("/marketplace/search/suggestions", {
        params: { q, country, limit },
    });
    return data || [];
};
